import script from "./Media-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Media-item.vue?vue&type=script&setup=true&lang=js"

import "./Media-item.vue?vue&type=style&index=0&id=d8bfd89c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8bfd89c"]])

export default __exports__